<template>
    <vueper-slides class="no-shadow" :visible-slides="3" slide-multiple :slide-ratio="1/3" :dragging-distance="400" :breakpoints="{ 800: { visibleSlides: 1 }}">
        <vueper-slide v-for="item in data" :key="item.id" >
            <div slot="slideContent" >
            <b-card
                    :img-src="(item.firstPhoto) ? '/static/uploads/'+item.firstPhoto: '/static/images/no_image.jpg'"
                    img-alt="Image"
                    img-top
                    img-height="168"
                    tag="article"
                    class="mb-1 px-0"
            >
                <b-card-text>
                    <p class="font-weight-bold my-0 ">{{  func_substring(item['title_'+selectedLocale.suffix.toLowerCase()], 40 ) }}</p>
<!--                    <small v-if="item.number">№ {{ item.number }}</small>-->
<!--                    <small v-else> <br/></small>-->
                    <hr/>
                    <div class="row">
                        <div class="col-6 " v-if="date">
                            <small class="mb-0 p-b-10 font-weight-bold">{{$t('message.expDate')}}</small>
                            <br/><small class="mt-0 p-t-10">{{date_format(item)}}</small>
                        </div>
                        <div class="col-6">
                            <small class="mb-0 p-b-10 font-weight-bold">{{$t('message.district')}}</small><br/>
                            <small class="mt-0 p-t-10">{{item['region_'+selectedLocale.suffix.toLowerCase()]}}</small>
                        </div>
                    </div>
                    <hr/>
                </b-card-text>

                <router-link :to="'/object/'+item.school_id"><b-button variant="primary">{{$t('message.more_info')}}</b-button></router-link>
            </b-card>
            </div>
        </vueper-slide>

    </vueper-slides>
</template>

<script>
    import { VueperSlides, VueperSlide } from 'vueperslides'
    import 'vueperslides/dist/vueperslides.css'
    import {format} from 'date-fns';
    import {  mapGetters } from "vuex";

    export default {
        props: ['date', 'data'],
        components: { VueperSlides, VueperSlide },
        computed: {
            ...mapGetters(["selectedLocale"])
        },
        data() {
            return {
            }
        },
        methods: {
            date_format(item) {
                var d = new Date(item.expDate)
                d.setTime( d.getTime() + d.getTimezoneOffset()*60*1000 );
             return format(d, 'yyyy-MM-dd HH:mm')
            },
            func_substring(val, count) {
                return  (val.length > count) ? val.substring(0,count)+'...' : val
            }
        }
    }
</script>

<style >
    .vueperslides {
        padding-top: 15px;
    }
    .vueperslide__content-wrapper {
        width: 90% !important;
    }
    @media only screen and (max-width: 1000px) and (min-width: 490px){
        .vueperslides__parallax-wrapper {
            padding-bottom: 55% !important;
        }
    }
    @media only screen and (max-width: 490px) and (min-width: 320px) {
        .vueperslides__parallax-wrapper {
            padding-bottom: 150% !important;
        }
    }
    @media only screen and (max-width: 320px) {
        .vueperslides__parallax-wrapper {
            padding-bottom: 200% !important;
        }
    }
    .vueperslides__bullets--outside .vueperslides__bullet--active {
        background-color: #42b983 !important;
        border: 1px solid #42b983;
    }
</style>
